<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                TERMO DE ABERTURA E USO DE CONTA DE PAGAMENTO
            </h2>
        </template>
        <div class="pt-16 pb-6">
            <flash :timeout="5000"/>
            <terms
                class="bg-white rounded overflow-y-scroll p-10 mx-auto terms"
                :infoTerms="infoTerms"
            />
            <div v-if="activeAccount.meta_data" class="mx-auto mt-10 grid terms">
                <label class="text-center items-center text-lg">
                    <span v-if="activeAccount.meta_data.user_name" class="ml-2"> Aceito por: {{
                            activeAccount.meta_data.user_name
                        }}</span> <br>
                    <span v-if="activeAccount.meta_data.created" class="ml-2"> Data de aceite do termo: {{
                            activeAccount.meta_data.created | smallDateTime
                        }}</span>
                </label>
            </div>
            <div v-else class="mx-auto mt-10 grid terms">
                <div v-if="is_main_user">
                    <label class="flex items-center text-lg">
                        <input v-model="form.terms_accepted" class="form-checkbox" type="checkbox">
                        <span class="ml-2">Li os termos e estou de acordo.</span>
                    </label>
                    <button class="mx-auto max-w-xs bg-green-500 text-sm hover:bg-green-700 text-white text-base font-bold my-0 py-3 px-6 rounded"
                            @click="acceptTerms()">
                        CONTINUAR
                    </button>
                </div>
                <div v-else class="grid text-center mt-10">
                    <p class="font-bold text-2xl">Apenas o titular da conta pode aceitar os termos.</p>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "./../../../Layouts/AppLayout";
import JetSectionBorder from "./../../../Jetstream/SectionBorder";
import Flash from "../../../Helpers/Flash"
import Terms from "./Terms.vue";

export default {
    props: ["sessions", "user", "is_main_user", "activeAccount", "infoTerms"],
    data() {
        return {
            form: this.$inertia.form({
                _method: 'POST',
                terms_accepted: false
            })
        }
    },
    components: {
        AppLayout,
        JetSectionBorder,
        Terms,
        Flash
    },
    methods: {
        acceptTerms() {
            if (!this.form.terms_accepted) {
                this.$toast.open({
                    message: 'É necessário aceitar os termos para continuar.',
                    type: 'error',
                    duration: 5000,
                    position: 'top-right'
                });
                return false;
            }
            this.form.post('/accept-terms', {
                preserveScroll: true,
                onError: (e) => {
                    this.form.processing = false;
                }
            });
        }
    }
};
</script>
